import { useEffect } from 'react'
import { useTheme } from 'styled-components'

const useThemeColor = () => {
    const theme = useTheme()

    useEffect(() => {
        const meta = document.querySelector('meta[name="theme-color"]')
        if (!meta) return
        meta.setAttribute('content', theme.nav.background)
    }, [theme.nav.background])
}

export default useThemeColor
